// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVideoOutlinedSvg from "@fishx/icons-svg/es/asn/PVideoOutlined";
import FishxIcon from '../components/FishxIcon';

var PVideoOutlined = function PVideoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVideoOutlinedSvg
  }));
};

PVideoOutlined.displayName = 'PVideoOutlined';
export default React.forwardRef(PVideoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVideoOutlined.js
// module id = 3725
// module chunks = 0